import Component from "@tunnel-components/@pages/supervision/simulator/home/component";
import * as React from "react";
import { connect } from "react-redux";
import * as Lodash from "lodash";

import {
  SimulatorActionCreator,
  IncidentTypesLoadedActionCreator,
  ExtractorCameraListActionCreator,
} from "@tunnel-store/index";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onChange
 * @name onStartDateChange
 * @name onSubmit
 * @name
 * @name componentDidUpdate
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     * @property { boolean }      state.errorserver
     * @property { boolean }      state.loading
     * ......
     */
    this.state = {
      btnloading: false,
      cameraIderror: false,
      error: false,
      errorserver: false,
      loading: false,
      selectedValue: "",
      selectedValueIncident: "",
      selectedOptions: null,
      selectedOptionsIncident: null,
      simulation: false,
      typeincidenterror: false,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onChange = this.onChange.bind(this);
    this.onEndDateChange = this.onEndDateChange.bind(this);
    this.onStartDateChange = this.onStartDateChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onGetValue = this.onGetValue.bind(this);
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      cameraIderror: false,
      error: false,
      simulation: false,
      typeincidenterror: false,
    }));
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.CameraListError !== this.props.CameraListError) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.CameraListError)) {
        this.setState((state: any): any => ({ errorserver: true }));
      }
      {
        /** Comparaison */
      }
    } else if (nextProps.cameraList !== this.props.cameraList) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.cameraList)) {
        this.setState((state: any): any => ({
          selectedOptions: nextProps.cameraList,
        }));
      }
    } else if (nextProps.IncidentTypeList !== this.props.IncidentTypeList) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.IncidentTypeList)) {
        this.setState((state: any): any => ({
          selectedOptionsIncident: nextProps.IncidentTypeList,
        }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      cameraIderror: false,
      error: false,
      errorserver: false,
      loading: true,
      typeincidenterror: false,
    }));
    this.props.IncidentTypesLoadedActionCreator();
    this.props
      .ExtractorCameraListActionCreator()
      .then(() => this.setState((state: any): any => ({ loading: false })));
  }
  /**
   * Manipulation  des inputs
   * @public
   * @method onChange
   * @param { any } value
   * @infos "https://reactjs.org"
   */
  public onChange(value: any) {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      cameraIderror: false,
      error: false,
      simulation: false,
      typeincidenterror: false,
    }));
    if (!Lodash.isEqual(value, "eudes")) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        typeincident: Number(value),
      }));
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        typeincident: undefined,
      }));
    }
  }
  /**
   * Manipulation  des date avec un date picker
   * @public
   * @external react-datepicker
   * @method onStartDateChange
   * @param { any } value
   * @infos "https://reactjs.org"
   */
  public onStartDateChange(value: any) {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      cameraIderror: false,
      error: false,
      simulation: false,
      startDate: value,
      typeincidenterror: false,
    }));
  }
  /**
   * Manipulation  des date avec un date picker
   * @public
   * @external react-datepicker
   * @method onEndDateChange
   * @param { any } value
   * @infos "https://reactjs.org"
   */
  public onEndDateChange(value: any) {
    {
      /** Empêcher la mutation du state */
    }

    this.setState((state: any): any => ({
      cameraIderror: false,
      endDate: value,
      error: false,
      simulation: false,
      typeincidenterror: false,
    }));
  }
  /**
   * Manipulation  des data pour la simulation
   * @public
   * @method onSubmit
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onSubmit = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** vérification de l'existence de l'élement  */
    }
    if (
      !Lodash.isEmpty(this.state.startDate) &&
      !Lodash.isEmpty(this.state.endDate) &&
      !Lodash.isUndefined(this.state.cameraId)
    ) {
      {
        /** Comparaison */
      }
      if (this.state.endDate > this.state.startDate) {
        if (Lodash.isNumber(this.state.cameraId)) {
          {
            /** Empêcher la mutation du state */
          }
          if (Lodash.isNumber(this.state.typeincident)) {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any): any => ({ btnloading: true }));
            this.props
              .SimulatorActionCreator(this.state)
              .then(() =>
                this.setState((state: any): any => ({ btnloading: false }))
              )
              .then(() =>
                this.setState((state: any): any => ({ simulation: true }))
              );
          } else {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any): any => ({ typeincidenterror: true }));
          }
        } else {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({ cameraIderror: true }));
        }
      } else {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ error: true }));
      }
    } else {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (
        Lodash.isEmpty(this.state.startDate) ||
        Lodash.isEmpty(this.state.endDate)
      ) {
        this.setState((state: any): any => ({ error: true }));
      }
      if (
        Lodash.isUndefined(this.state.cameraId) ||
        !Lodash.isNumber(this.state.cameraId)
      ) {
        this.setState((state: any): any => ({ cameraIderror: true }));
      }
      if (
        Lodash.isUndefined(this.state.typeincident) ||
        !Lodash.isNumber(this.state.typeincident)
      ) {
        this.setState((state: any): any => ({ typeincidenterror: true }));
      }
    }
  };
  /**
   * Changement des etats des inputs
   * @method onGetValue
   * @param { any }  value
   * @infos "https://reactdatepicker.com/"
   */
  public onGetValue = (value: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    // event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      cameraIderror: false,
      error: false,
      errorserver: false,
      typeincidenterror: false,
    }));
    if (!Lodash.isEqual(value, "eudes")) {
      this.setState((state: any): any => ({
        cameraId: Number(value),
      }));
    } else {
      this.setState((state: any): any => ({
        cameraId: undefined,
      }));
    }
  };

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        onGetValue={this.onGetValue}
        onChange={this.onChange}
        onStartDateChange={this.onStartDateChange}
        onEndDateChange={this.onEndDateChange}
        onSubmit={this.onSubmit}
        {...this.props}
        {...this.state}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    cameraList: state.ExtractorCameraList.data,
    CameraListError: state.ExtractorCameraList.error,
    IncidentTypeList: state.IncidentTypesLoaded.data,
    error: state.ExtractorCameraList.error,
    // loading : state.ExtractorCameraList.loading || state.IncidentTypesLoaded.loading
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  ExtractorCameraListActionCreator,
  SimulatorActionCreator,
  IncidentTypesLoadedActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/simulator/home/container.tsx